import { inject, Injectable, Renderer2 } from '@angular/core';
import { environment } from '../../environments/environment';

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

function fbq(arg0: string, arg1: string) {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq(arg0, arg1);
  } else {
    // Optionally, you can log or silently ignore if fbq is not loaded
    console.warn('Meta Pixel (fbq) is not loaded.');
  }
}

@Injectable({
  providedIn: 'root',
})
export class MetaPixelAnalytics {
  initializeMetaPixel() {
    if (!environment.production) {
      return; // Skip initialization in non-production environments
    }
    this.loadScript();
  }

  loadScript(): void {
    const script = document.createElement('script');
    script.src = 'assets/scripts/meta-pixel.js';
    script.type = 'text/javascript';
    script.async = true;
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img
        height="1"
        width="1"
        style="display: none"
        src="https://www.facebook.com/tr?id=2158961497728088&ev=PageView&noscript=1"
      />`;
    document.body.appendChild(noscript);
  }
}
